import React from "react";
import { Link } from "react-router-dom";

export const Question = ({ question }) => {
  return (
    <div>
      <Link to={`/mcq-questions/${question.id}/edit`}>{question.question}</Link>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/modules/admin/mcqQuestions/components/Question.js